/* ==========================================================================
   BACK IN STOCK ALERT (NEW FILE)
   Custom element <back-in-stock-form>, rendered by snippets/buy-now-button.liquid
   when the selected variant is sold out and the alert is enabled in the
   Buy now block settings.

   Submits Shopify's contact form with fetch so the customer stays on the
   product page (and keeps the selected variant), then shows the success text
   configured in the theme editor.
   ========================================================================== */

(function () {
  if (customElements.get('back-in-stock-form')) return;

  class BackInStockForm extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.form = this.querySelector('form');
      this.button = this.querySelector('.bis_alert__button');
      this.loader = this.querySelector('.form_loader');
      this.buttonText = this.querySelector('.bis_alert__button-text');
      this.status = this.querySelector('.bis_alert__status');
      if (!this.form) return;

      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    setLoading(isLoading) {
      if (this.button) this.button.disabled = isLoading;
      this.loader?.classList.toggle('hidden', !isLoading);
      this.buttonText?.classList.toggle('hidden', isLoading);
    }

    showStatus(text, isError) {
      if (!this.status) return;
      this.status.textContent = text;
      this.status.classList.toggle('is-error', Boolean(isError));
      this.status.classList.add('is-visible');
    }

    async onSubmit(e) {
      e.preventDefault();
      this.setLoading(true);
      this.status?.classList.remove('is-visible');

      try {
        const res = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        // Shopify shows a captcha challenge page when it suspects spam: fall back to a normal submit
        if (res.url.includes('/challenge')) {
          this.form.removeEventListener('submit', this.onSubmit);
          this.form.submit();
          return;
        }

        if (res.ok && res.url.includes('contact_posted=true')) {
          // Success: hide the form + intro text and show the success message
          this.form.classList.add('hidden');
          this.querySelector('.bis_alert__message')?.classList.add('hidden');
          this.showStatus(this.dataset.success, false);
        } else {
          this.showStatus(this.dataset.error, true);
        }
      } catch (err) {
        this.showStatus(this.dataset.error, true);
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('back-in-stock-form', BackInStockForm);
})();
